// Testimonials/Arvostelut/Blog Posts/Contact Card Carousel sliders values
// Link to documentation: https://kenwheeler.github.io/slick/


  function createSlick() {
    // Testimonial M
    jQuery('.testimonial-slider-m').not('.slick-initialized').slick({
      lazyLoad: 'ondemand',
      slidesToShow: 2,
      slidesToScroll: 2,
      dots: false,
      arrows: true,
      adaptiveHeight: true,
      infinite: false,
      centerMode: false,
      draggable: false,
      speed: 600,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            arrows: true,
            draggable: true,
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });

    // Testimonial L
    jQuery('.testimonial-slider-l').not('.slick-initialized').slick ({
      lazyLoad: 'ondemand',
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: false,
      arrows: true,
      adaptiveHeight: true,
      infinite: false,
      centerMode: false,
      draggable: false,
      speed: 600,
      responsive: [
        {
          breakpoint: 950,
          settings: {
            arrows: true,
            draggable: true,
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });

    // Content Card Carousel
    jQuery('.offers-1').not('.slick-initialized').slick({
      lazyLoad: 'ondemand',
      slidesToShow: 1,
      dots: false,
      arrows: false,
      adaptiveHeight: false,
      infinite: false,
      centerMode: true,
      draggable: false,
      variableWidth: false,
      speed: 600,
      responsive: [
        {
          breakpoint: 850,
          settings: {
            arrows: false,
            draggable: true,
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });
      
    jQuery('.offers-2').not('.slick-initialized').slick({
      lazyLoad: 'ondemand',
      slidesToShow: 2,
      slidesToScroll: 1,
      dots: false,
      arrows: true,
      adaptiveHeight: false,
      infinite: false,
      centerMode: false,
      draggable: false,
      variableWidth: true,
      speed: 600,
      responsive: [
        {
          breakpoint: 650,
          settings: {
            arrows: false,
            draggable: true,
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });
      
    jQuery('.offers-3').not('.slick-initialized').slick({
      lazyLoad: 'ondemand',
      slidesToShow: 3,
      slidesToScroll: 1,
      dots: false,
      arrows: true,
      adaptiveHeight: false,
      infinite: false,
      centerMode: false,
      draggable: false,
      variableWidth: true,
      speed: 600,
      responsive: [
        {
          breakpoint: 1279,
          settings: {
            arrows: true,
            draggable: true,
            slidesToShow: 1,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 850,
          settings: {
            arrows: false,
            draggable: true,
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });
      
    jQuery('.offers-4').not('.slick-initialized').slick({
      lazyLoad: 'ondemand',
      slidesToShow: 4,
      slidesToScroll: 1,
      dots: false,
      arrows: true,
      adaptiveHeight: false,
      infinite: false,
      centerMode: false,
      draggable: false,
      variableWidth: true,
      speed: 600,
      responsive: [
        {
          breakpoint: 1830,
          settings: {
            arrows: true,
            draggable: true,
            slidesToShow: 1,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 850,
          settings: {
            arrows: false,
            draggable: true,
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });
      
    jQuery('.offers-5').not('.slick-initialized').slick({
      lazyLoad: 'ondemand',
      slidesToShow: 4,
      slidesToScroll: 1,
      dots: false,
      arrows: false,
      adaptiveHeight: false,
      infinite: false,
      centerMode: false,
      draggable: false,
      variableWidth: true,
      speed: 600,
      responsive: [
        {
          breakpoint: 2200,
          settings: {
            arrows: true,
            draggable: true,
            slidesToShow: 1,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 850,
          settings: {
            arrows: false,
            draggable: true,
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });
      
    jQuery('.over-5').not('.slick-initialized').slick({
      lazyLoad: 'ondemand',
      slidesToShow: 4,
      slidesToScroll: 1,
      dots: false,
      arrows: true,
      adaptiveHeight: false,
      infinite: false,
      centerMode: false,
      draggable: false,
      variableWidth: true,
      speed: 600,
      responsive: [
        {
          breakpoint: 2300,
          settings: {
            arrows: true,
            draggable: true,
            slidesToShow: 2,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 850,
          settings: {
            arrows: false,
            draggable: true,
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });
    
  }

  createSlick();
  //Now it will not throw error, even if called multiple times.
  jQuery(window).on( 'resize', createSlick );
